import { Component, Inject, OnInit, Optional, Input, Output, EventEmitter } from '@angular/core';
import { Submission } from 'src/app/model/paper';
import { Track } from 'src/app/model/track';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormArray, FormControl } from '@angular/forms';
import { RankedSubmission } from '../submissions-list-table/submissions-list-table.component';

@Component({
  selector: 'app-verify-similarity-dialog',
  templateUrl: './verify-similarity-dialog.component.html',
  styleUrls: ['./verify-similarity-dialog.component.scss']
})
export class VerifySimilarityDialogComponent implements OnInit {
  rankedSubmissions: RankedSubmission[];
  tracks: Track[];
  submissions: Submission[] = [];
  form: FormGroup;
  submissionsTracks: number[] = [];

  constructor(
    public dialogRef: MatDialogRef<VerifySimilarityDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { rankedSubmissions: RankedSubmission[], tracks: Track[] }
  ) {
    this.rankedSubmissions = data.rankedSubmissions;
    this.rankedSubmissions.forEach(rankedSubmission => this.submissions.push(rankedSubmission.submission))
    this.submissionsTracks = this.submissionsTracksIds()
    this.tracks = this.removeUnselectedTracks(data.tracks);
  }

  ngOnInit() {  
    this.form = this.fb.group({
      trackFiles: this.fb.array(this.tracks.map(track => 
        this.fb.group({
          trackId: track.id,
          files: this.fb.array(track.trackFiles.map(() => this.fb.control(false)))
        })
      ))
    });
  }

  private submissionsTracksIds(): number[] {
    var tracks = new Set<number>();

    this.submissions.forEach(submission => {
      if (submission.track instanceof Track) {
        submission.track.trackFiles
        tracks.add(submission.track.id);
      }  else if (typeof submission.track === 'number') {
        tracks.add(submission.track);
      }
    });

    return Array.from(tracks);
  }

  private removeUnselectedTracks(tracks: Track[]): Track[] {
    var filteredTracks : Track[] = []
    tracks.forEach(track => {
      this.submissionsTracks.forEach(submissionTrackId => {
        if(track.id == submissionTrackId)
          filteredTracks.push(track)
      } )
    })
    return filteredTracks;
  }

  get trackFiles(): FormArray {
    return this.form.get('trackFiles') as FormArray;
  }

  getFilesArray(trackIndex: number): FormArray {
    return this.trackFiles.at(trackIndex).get('files') as FormArray;
  }

  public confirm(): void {
    const selectedFiles = this.form.value.trackFiles
    .flatMap((track, i) =>
      track.files
        .map((selected, j) => selected ? this.tracks[i].trackFiles[j] : null)
        .filter(file => file !== null)
    );

  const selectedFilesFromSubmissions = this.submissions
  .flatMap(submission =>
    submission.files.filter(submissionFile =>
      selectedFiles.some(selectedFile => submissionFile.trackFile.id === selectedFile.id)
    )
  );

  this.dialogRef.close(selectedFilesFromSubmissions);
  }

  public close(): void {
    this.dialogRef.close();
  }
  
  someTrackfileSelected(): boolean{
    return this.form.value.trackFiles.some((track) => track.files.some(trackFile => trackFile));
  }
}